import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classPrivateFieldLooseBase from "@babel/runtime/helpers/esm/classPrivateFieldLooseBase";
import _classPrivateFieldLooseKey from "@babel/runtime/helpers/esm/classPrivateFieldLooseKey";
// 1s empty file. To the exact byte. Edit only if you know what you're doing.
const emptyAudio = `data:audio/wav;base64,UklGRi5FAABXQVZFZm10IBAAAAABAAIARKwAABCxAgAEABAATElTVBoAAABJTkZPSVNGVA0AAABMYXZmNjEuMS4xMDAAAGRhdGHoR${'A'.repeat(23523)}`;
var _element = /*#__PURE__*/_classPrivateFieldLooseKey("element");
var _unlocked = /*#__PURE__*/_classPrivateFieldLooseKey("unlocked");
var _onEnded = /*#__PURE__*/_classPrivateFieldLooseKey("onEnded");
var _onError = /*#__PURE__*/_classPrivateFieldLooseKey("onError");
var _onPlay = /*#__PURE__*/_classPrivateFieldLooseKey("onPlay");
var _onPlaying = /*#__PURE__*/_classPrivateFieldLooseKey("onPlaying");
var _onStarted = /*#__PURE__*/_classPrivateFieldLooseKey("onStarted");
var _onTimeUpdate = /*#__PURE__*/_classPrivateFieldLooseKey("onTimeUpdate");
var _unlockOnUserInteraction = /*#__PURE__*/_classPrivateFieldLooseKey("unlockOnUserInteraction");
export default class Previewer {
  constructor({
    autoplay = true,
    autoUnlock = true,
    volume = 0.5,
    onEnded,
    onError,
    onPlay,
    onPlaying,
    onStarted,
    onTimeUpdate
  } = {}) {
    Object.defineProperty(this, _unlockOnUserInteraction, {
      value: _unlockOnUserInteraction2
    });
    Object.defineProperty(this, _element, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _unlocked, {
      writable: true,
      value: false
    });
    Object.defineProperty(this, _onEnded, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _onError, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _onPlay, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _onPlaying, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _onStarted, {
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, _onTimeUpdate, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _element)[_element] = document.createElement('audio');
    this.unlock().then(unlocked => {
      _classPrivateFieldLooseBase(this, _unlocked)[_unlocked] = unlocked;
    });
    if (autoUnlock) {
      _classPrivateFieldLooseBase(this, _unlockOnUserInteraction)[_unlockOnUserInteraction]();
    }
    _classPrivateFieldLooseBase(this, _element)[_element].autoplay = autoplay;
    _classPrivateFieldLooseBase(this, _element)[_element].volume = volume;
    if (onEnded) {
      _classPrivateFieldLooseBase(this, _onEnded)[_onEnded] = onEnded;
      _classPrivateFieldLooseBase(this, _element)[_element].addEventListener('ended', _classPrivateFieldLooseBase(this, _onEnded)[_onEnded]);
    }
    if (onError) {
      _classPrivateFieldLooseBase(this, _onError)[_onError] = onError;
      _classPrivateFieldLooseBase(this, _element)[_element].addEventListener('error', _classPrivateFieldLooseBase(this, _onError)[_onError]);
    }
    if (onPlay) {
      _classPrivateFieldLooseBase(this, _onPlay)[_onPlay] = onPlay;
      _classPrivateFieldLooseBase(this, _element)[_element].addEventListener('play', _classPrivateFieldLooseBase(this, _onPlay)[_onPlay]);
    }
    if (onPlaying) {
      _classPrivateFieldLooseBase(this, _onPlaying)[_onPlaying] = onPlaying;
      _classPrivateFieldLooseBase(this, _element)[_element].addEventListener('playing', _classPrivateFieldLooseBase(this, _onPlaying)[_onPlaying]);
    }
    if (onStarted) {
      _classPrivateFieldLooseBase(this, _onStarted)[_onStarted] = onStarted;
      _classPrivateFieldLooseBase(this, _element)[_element].addEventListener('play', _classPrivateFieldLooseBase(this, _onStarted)[_onStarted]);
    }
    if (onTimeUpdate) {
      _classPrivateFieldLooseBase(this, _onTimeUpdate)[_onTimeUpdate] = onTimeUpdate;
      _classPrivateFieldLooseBase(this, _element)[_element].addEventListener('timeupdate', _classPrivateFieldLooseBase(this, _onTimeUpdate)[_onTimeUpdate]);
    }
  }
  /**
   * Tries to unlock
   *
   * @returns is the element unlockeds
   */

  unlock() {
    var _this = this;
    return _asyncToGenerator(function* () {
      _classPrivateFieldLooseBase(_this, _element)[_element].src = emptyAudio;
      try {
        yield _classPrivateFieldLooseBase(_this, _element)[_element].play();
        _this.stop();
        return true;
      } catch (_unused) {
        return false;
      }
    })();
  }
  get locked() {
    return !_classPrivateFieldLooseBase(this, _unlocked)[_unlocked];
  }
  get currentTime() {
    return _classPrivateFieldLooseBase(this, _element)[_element].currentTime;
  }
  get duration() {
    return _classPrivateFieldLooseBase(this, _element)[_element].duration;
  }
  addEventListener(type, callback, options) {
    _classPrivateFieldLooseBase(this, _element)[_element].addEventListener(type, callback, options);
  }
  removeEventListener(type, callback) {
    _classPrivateFieldLooseBase(this, _element)[_element].removeEventListener(type, callback);
  }
  destruct() {
    if (_classPrivateFieldLooseBase(this, _onEnded)[_onEnded]) {
      _classPrivateFieldLooseBase(this, _element)[_element].removeEventListener('ended', _classPrivateFieldLooseBase(this, _onEnded)[_onEnded]);
    }
    if (_classPrivateFieldLooseBase(this, _onError)[_onError]) {
      _classPrivateFieldLooseBase(this, _element)[_element].removeEventListener('error', _classPrivateFieldLooseBase(this, _onError)[_onError]);
    }
    if (_classPrivateFieldLooseBase(this, _onPlay)[_onPlay]) {
      _classPrivateFieldLooseBase(this, _element)[_element].removeEventListener('play', _classPrivateFieldLooseBase(this, _onPlay)[_onPlay]);
    }
    if (_classPrivateFieldLooseBase(this, _onPlaying)[_onPlaying]) {
      _classPrivateFieldLooseBase(this, _element)[_element].removeEventListener('playing', _classPrivateFieldLooseBase(this, _onPlaying)[_onPlaying]);
    }
    if (_classPrivateFieldLooseBase(this, _onStarted)[_onStarted]) {
      _classPrivateFieldLooseBase(this, _element)[_element].removeEventListener('play', _classPrivateFieldLooseBase(this, _onStarted)[_onStarted]);
    }
    if (_classPrivateFieldLooseBase(this, _onTimeUpdate)[_onTimeUpdate]) {
      _classPrivateFieldLooseBase(this, _element)[_element].removeEventListener('timeupdate', _classPrivateFieldLooseBase(this, _onTimeUpdate)[_onTimeUpdate]);
    }
    _classPrivateFieldLooseBase(this, _element)[_element].remove();
  }

  /**
   * Load a given preview
   * @param url The preview's URL
   */
  load(url) {
    _classPrivateFieldLooseBase(this, _element)[_element].src = url;
    _classPrivateFieldLooseBase(this, _element)[_element].load(); // Will reset any existing error
  }
  get muted() {
    return _classPrivateFieldLooseBase(this, _element)[_element].muted;
  }
  set muted(value) {
    _classPrivateFieldLooseBase(this, _element)[_element].muted = Boolean(value);
  }

  /**
   * Pause the playback
   * @return Return a resolving promise (in order to be consistent with play())
   */
  pause() {
    _classPrivateFieldLooseBase(this, _element)[_element].pause();
    return Promise.resolve();
  }

  /**
   * Launch the playback
   * @return Return a promise (@see https://developer.mozilla.org/en-US/docs/Web/API/HTMLMediaElement/play)
   */
  play() {
    return _classPrivateFieldLooseBase(this, _element)[_element].play() || Promise.resolve();
    // For older browsers, return a resolving promise
  }

  /**
   * Pause the playback and stop buffering
   */
  stop() {
    this.pause();
    _classPrivateFieldLooseBase(this, _element)[_element].src = ''; // Reset the source to "unload" the player (especially for clear content)
    _classPrivateFieldLooseBase(this, _element)[_element].removeAttribute('src'); // Prevent MEDIA_ELEMENT_ERROR DOM error
    return Promise.resolve();
  }
  get url() {
    return _classPrivateFieldLooseBase(this, _element)[_element].src;
  }
  get volume() {
    return _classPrivateFieldLooseBase(this, _element)[_element].volume;
  }
  set volume(value) {
    _classPrivateFieldLooseBase(this, _element)[_element].volume = value;
  }
}
function _unlockOnUserInteraction2() {
  var _this2 = this;
  const _unlock = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* () {
      document.removeEventListener('touchstart', _unlock, true);
      document.removeEventListener('touchend', _unlock, true);
      document.removeEventListener('click', _unlock, true);
      document.removeEventListener('keydown', _unlock, true);
      _classPrivateFieldLooseBase(_this2, _unlocked)[_unlocked] = yield _this2.unlock();
    });
    return function unlock() {
      return _ref.apply(this, arguments);
    };
  }();
  document.addEventListener('touchstart', _unlock, true);
  document.addEventListener('touchend', _unlock, true);
  document.addEventListener('click', _unlock, true);
  document.addEventListener('keydown', _unlock, true);
}
//# sourceMappingURL=Previewer.js.map